import { createReducer, on } from '@ngrx/store';
import { TipologieMezziActions } from './tipologie-mezzi.actions';
import { TipologiaMezzo } from '../../core/models/garage.model';

export interface TipologieMezziState {
  items: TipologiaMezzo[];
  loaded: boolean;
  loading: boolean;
  error: string | null;
  opLoading: boolean;
  opError: string | null;
  createSuccessCount: number;
  createFailureCount: number;
  lastCreatedId: number | null;
}

export const initialState: TipologieMezziState = {
  items: [],
  loaded: false,
  loading: false,
  error: null,
  opLoading: false,
  opError: null,
  createSuccessCount: 0,
  createFailureCount: 0,
  lastCreatedId: null,
};

const toId = (v: unknown) => String(v ?? '');

export const tipologieMezziReducer = createReducer(
  initialState,

  on(TipologieMezziActions.loadList, (s) =>
    s.loaded ? s : { ...s, loading: true, error: null }
  ),
  on(TipologieMezziActions.loadListSuccess, (s, { items }) => ({
    ...s,
    loading: false,
    loaded: true,
    items,
  })),
  on(TipologieMezziActions.loadListFailure, (s, { error }) => ({
    ...s,
    loading: false,
    error,
  })),

  on(TipologieMezziActions.create, (s) => ({ ...s, opLoading: true, opError: null })),
  on(TipologieMezziActions.createSuccess, (s, { id }) => ({
    ...s,
    opLoading: false,
    loaded: false,
    createSuccessCount: s.createSuccessCount + 1,
    lastCreatedId: id,
  })),
  on(TipologieMezziActions.createFailure, (s, { error }) => ({
    ...s,
    opLoading: false,
    opError: error,
    createFailureCount: s.createFailureCount + 1,
  })),

  on(TipologieMezziActions.delete, (s) => ({ ...s, opLoading: true, opError: null })),
  on(TipologieMezziActions.deleteSuccess, (s, { id }) => ({
    ...s,
    opLoading: false,
    items: s.items.filter(x => toId(x.id) !== toId(id)),
  })),
  on(TipologieMezziActions.deleteFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),
);
